import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navbar } from '../components/Navbar';
import { Store, User, Save } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const Settings = () => {
  const { user, setUser } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    store_name: user?.store_name || 'Needi'
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.put(
        `${API_URL}/auth/profile`,
        formData,
        { withCredentials: true }
      );
      
      setUser(response.data.user);
      toast.success('Configurações atualizadas com sucesso!');
    } catch (error) {
      const message = error.response?.data?.detail || 'Erro ao atualizar configurações';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-testid="settings-title">
            Configurações
          </h1>
          <p className="text-lg text-gray-600">Personalize sua vitrine e perfil</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Store Name */}
            <div>
              <div className="flex items-center space-x-2 mb-3">
                <Store className="w-5 h-5 text-indigo-600" />
                <Label className="text-lg font-semibold text-gray-900">Nome da Vitrine</Label>
              </div>
              <p className="text-sm text-gray-600 mb-3">
                Este é o nome que aparecerá no topo da sua vitrine
              </p>
              <Input
                value={formData.store_name}
                onChange={(e) => setFormData({ ...formData, store_name: e.target.value })}
                placeholder="Ex: Loja do João, Boutique Maria..."
                className="text-lg"
                data-testid="store-name-input"
              />
              <p className="text-xs text-gray-500 mt-2">
                Preview: <span className="font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                  {formData.store_name || 'Needi'}
                </span>
              </p>
            </div>

            <div className="border-t border-gray-200 pt-6">
              <div className="flex items-center space-x-2 mb-3">
                <User className="w-5 h-5 text-indigo-600" />
                <Label className="text-lg font-semibold text-gray-900">Seu Nome</Label>
              </div>
              <Input
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Seu nome completo"
                data-testid="name-input"
              />
            </div>

            <div className="border-t border-gray-200 pt-6">
              <div className="bg-indigo-50 rounded-lg p-4 mb-4">
                <h3 className="font-semibold text-indigo-900 mb-2">💡 Dica</h3>
                <p className="text-sm text-indigo-800">
                  Escolha um nome único e memorável para sua vitrine! Isso ajuda seus clientes a 
                  lembrarem da sua loja e compartilharem com outras pessoas.
                </p>
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700"
                data-testid="save-settings-btn"
              >
                <Save className="w-4 h-4 mr-2" />
                {loading ? 'Salvando...' : 'Salvar Alterações'}
              </Button>
            </div>
          </form>
        </div>

        {/* Additional Info */}
        <div className="mt-6 bg-gray-50 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-2">Informações da Conta</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <p><span className="font-medium">Email:</span> {user?.email}</p>
            <p><span className="font-medium">Tipo de conta:</span> {
              user?.role === 'admin' ? 'Administrador' : 
              user?.role === 'seller' ? 'Vendedor' : 
              'Cliente'
            }</p>
            {user?.role === 'seller' && (
              <p>
                <span className="font-medium">Status:</span> 
                <span className={`ml-2 px-2 py-1 rounded text-xs font-medium ${
                  user?.approved ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                }`}>
                  {user?.approved ? 'Aprovado' : 'Pendente de Aprovação'}
                </span>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
